import { useContext } from 'react';
import styles from './BusinessConfiguration.module.scss';
import { Heading } from '../../ui/components/Heading/Heading';
import { ChangeBusinessHours } from './components/ChangeBusinessHours/ChangeBusinessHours';
import { InitialContext } from '../Layout/Layout';

export const BusinessConfiguration = () => {
  const { company } = useContext(InitialContext);
  return (
    <div className={styles.root}>
      <Heading className={styles.heading} headingLevel="h1">
        {`${company?.name} Business Configuration`}
      </Heading>
      <div className={styles['working-time']}>
        <Heading className={styles.heading} headingLevel="h2">
          Horario laboral
        </Heading>
        <ChangeBusinessHours />
      </div>
    </div>
  );
};
